/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto } from '../models/Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto';
import type { Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_SettlementTypeDto } from '../models/Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_SettlementTypeDto';
import type { Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EarlyExerciseConfigurationService {

    /**
     * @param planTypeCategoryName
     * @returns Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppEarlyExerciseConfigurationEarlyExerciseConfiguration(
        planTypeCategoryName?: string,
    ): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/early-exercise-configuration/early-exercise-configuration',
            query: {
                'planTypeCategoryName': planTypeCategoryName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_SettlementTypeDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppEarlyExerciseConfigurationCashSellTypeSettlementTypes(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_SettlementTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/early-exercise-configuration/cash-sell-type-settlement-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppEarlyExerciseConfigurationConfigureEarlyExerciseConfiguration(
        requestBody?: Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto,
    ): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/early-exercise-configuration/configure-early-exercise-configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
